export default __webpack_public_path__ + "static/media/chipp.d1fb601c.svg";